import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import Container from "@/components/containers/Container";
import Tab from "@/components/containers/tabs/Tab";
import TabGroup from "@/components/containers/tabs/TabGroup";
import TabList from "@/components/containers/tabs/TabList";
import TabPanel from "@/components/containers/tabs/TabPanel";
import TabPanels from "@/components/containers/tabs/TabPanels";
import type { ChildRouteContext } from "@/root";

import CheckinList from "@/modules/performance/user/components/checkins/CheckinList";

export const Route = createFileRoute(
  "/_panel/_performance/performance/checkins/",
)({
  component: RouteComponent,
  beforeLoad: ({ context }) =>
    ({
      crumb: [
        {
          label: context.t("Periodic Meetings", { ns: "performance.user" }),
        },
      ],
    }) satisfies ChildRouteContext,
});

function RouteComponent() {
  const { t } = useTranslation("performance.user");
  return (
    <Container
      title={t("Periodic Meetings")}
      description={t(
        "Set up regular meetings to continuously track performance and receive consistent feedback.",
      )}
    >
      <div>
        <TabGroup>
          <TabList>
            <Tab>{t("All", { ns: "core.shared" })}</Tab>
            <Tab>{t("Inbox", { ns: "core.shared" })}</Tab>
          </TabList>
          <TabPanels>
            <TabPanel>
              <CheckinList />
            </TabPanel>
            <TabPanel>
              <CheckinList isInbox />
            </TabPanel>
          </TabPanels>
        </TabGroup>
      </div>
    </Container>
  );
}
